import { Component } from '@angular/core';

// Shown to a foreigner without any user-process / work-permit when purchasing is disabled for his company.
@Component({
  selector: 'app-no-processes-available',
  templateUrl: './no-processes-available.component.html',
  styleUrls: ['./no-processes-available.component.scss'],
  standalone: false,
})
export class NoProcessesAvailableComponent {}
